module.exports = __webpack_public_path__ + "img/logo.9d7bc5a3.png";